function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".proveedores_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.3px}"));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  className: "proveedores_svg__cls-1",
  d: "M53.17 42.18s-3-3.12-3.89-3.92a4.59 4.59 0 00-3-1.09H33a3.23 3.23 0 100 6.46h6.05a3 3 0 012.66 1.49M45.36 49.72a3.08 3.08 0 00-2.66-1.51s-15.3.24-17 .24a3.09 3.09 0 01-2.18-.88c-.55-.54-7.86-8-7.86-8M15.67 39.57a2.9 2.9 0 01-.8-2 3 3 0 013-3 3 3 0 011.87.63L27 40.8a3.34 3.34 0 001.73.61h.89M43.81 36.94V18.32H21.73v18.01"
});

var SvgProveedores = function SvgProveedores(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "proveedores_svg__Capa_1",
    "data-name": "Capa 1",
    height: 18,
    width: 20,
    viewBox: "0 0 65 55"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBoZWlnaHQ9IjE4IiB3aWR0aD0iMjAiIHZpZXdCb3g9IjAgMCA2NSA1NSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOmN1cnJlbnRDb2xvcjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjEuM3B4O308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik01My4xNyw0Mi4xOHMtMy0zLjEyLTMuODktMy45MmE0LjU5LDQuNTksMCwwLDAtMy0xLjA5SDMzYTMuMjMsMy4yMywwLDEsMCwwLDYuNDZjMS44MywwLDYuMDUsMCw2LjA1LDBhMywzLDAsMCwxLDIuNjYsMS40OSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTQ1LjM2LDQ5LjcyYTMuMDgsMy4wOCwwLDAsMC0yLjY2LTEuNTFzLTE1LjMuMjQtMTcsLjI0YTMuMDksMy4wOSwwLDAsMS0yLjE4LS44OGMtLjU1LS41NC03Ljg2LTgtNy44Ni04Ii8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTUuNjcsMzkuNTdhMi45LDIuOSwwLDAsMS0uOC0yLDMsMywwLDAsMSwzLTMsMywzLDAsMCwxLDEuODcuNjNMMjcsNDAuOGEzLjM0LDMuMzQsMCwwLDAsMS43My42MWguODkiLz48cG9seWxpbmUgY2xhc3M9ImNscy0xIiBwb2ludHM9IjQzLjgxIDM2Ljk0IDQzLjgxIDE4LjMyIDIxLjczIDE4LjMyIDIxLjczIDM2LjMzIi8+PC9zdmc+";
export { SvgProveedores as ReactComponent };